import React from "react";
import t from "../../../helpers/t";
import {_, moment} from '../../../../../vendor';
import { rbac } from "../index";
import {dateFormat} from "../../../../utils/FormatHelper";
import {Biscuit} from "../../../../utils";
import {HtmlTooltip, ADJUSTMENT_HELP_TEXT} from "../../../../utils/HelperOld";
import {checkAndParseJson} from "../../../../utils/Helper";
import {Reservation} from "../../../components/Types/Reservation";
import {Checkin} from "../../../components/Types/Checkin";
import {Location} from "../../../components/Types/Location";
//import { Tooltip } from 'react-tooltip';
/*import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import {Typography} from "@mui/material";*/

type Props = {
    reservation: Reservation,
    checkin: Checkin,
    checkins: null|[]|[Checkin]|any,
    locations: null|[]|[Location]|any,
    id: number,
    order_id: null | number,
    app_user_role: string,
    checkout: boolean,
    dispatch: any,
    setCheckout: any,
    filter: any,
    sort: any,
    _key: string,
    setCheckoutReservation: (reservation: Reservation) => void,
    setCheckoutCheckin: (checkin: Checkin) => void,
    setFilter: (filter: any) => void,
    setSort: (sort: any) => void,
    setNKey: (nKey: string) => void,

}

const CheckInAddition = (props:Props) => {
    let language: string = Biscuit.get('user.lang').replace('-','_');
    const openCheckin = (ev:any, checkin:Checkin) => {
        props.setCheckoutReservation(props.reservation);
        props.setCheckoutCheckin(checkin);
        props.setFilter(props.filter);
        props.setSort(props.sort);
        props.setNKey(props._key);
        props.setCheckout(true);

    };
    let checkout_completed:boolean = _.every(props.checkins, function (checkin: Checkin) {
        return typeof checkin?.checkout !== 'undefined' && checkin?.checkout !== null
    });
    return (
        <>
            {props.checkins !== null && !props.checkout && props.checkins.map((checkin: Checkin,index: number) => {
                let showInfoIcon = false, showInfoIconIn = false;
                let infoText: string|undefined = checkAndParseJson(checkin.comment_checkout);
                if(typeof infoText === 'undefined') infoText = '';
                let infoTextIn: string|undefined = checkAndParseJson(checkin.comment_checkin);
                if(typeof infoTextIn === 'undefined') infoTextIn = '';
                if(props.checkins !== null && (index+1) === props.checkins.length){
                    infoText += (infoText !== ''?'//':'')+checkAndParseJson(props.reservation.external_note);
                }
                if(typeof checkin?.place_checkout !== 'undefined' && checkin?.place_checkout !== null){
                    infoText += (infoText !== ''?'//':'')+checkAndParseJson(checkin.place_checkout);
                }
                if(typeof checkin?.place_checkin !== 'undefined' && checkin?.place_checkin !== null){
                    infoTextIn += (infoTextIn !== ''?'//':'')+checkAndParseJson(checkin.place_checkin);
                }
                if(infoText !== ''){
                    showInfoIcon = true;
                }
                if(infoTextIn !== ''){
                    showInfoIconIn = true;
                }
                if(typeof props.locations !== 'undefined' && props.locations !== null) {
                    if (typeof checkin.location_checkin_name === 'undefined' || checkin.location_checkin_name === '' || checkin.location_checkin_name === null) {
                        if (checkin.location_checkin !== null && typeof checkin.location_checkin !== 'undefined' && typeof props.locations[checkin.location_checkin] !== 'undefined' && typeof props.locations[checkin.location_checkin].name !== 'undefined') {
                            checkin.location_checkin_name = props.locations[checkin.location_checkin].name;
                        } else {
                            checkin.location_checkin_name = '';
                        }
                    }
                    if (typeof checkin.location_checkout_name === 'undefined' || checkin.location_checkout_name === '' || checkin.location_checkout_name === null) {
                        if (checkin.location_checkout !== null && typeof checkin.location_checkout !== 'undefined' && typeof props.locations[checkin.location_checkout] !== 'undefined' && typeof props.locations[checkin.location_checkout].name !== 'undefined') {
                            checkin.location_checkout_name = props.locations[checkin.location_checkout].name;
                        } else {
                            checkin.location_checkout_name = '';
                        }
                    }
                }
                return (<>
                    {/* WEB */}
                    <div className="inb-reservation inb-reservation--bikesharing inb-c-item-details-row row hide-for-small-only"
                         style={{marginInline: "16px", paddingBottom: "0", backgroundColor: "#f3f3f3"}}
                         data-inb-reservation={props.id}
                         data-inb-context="reservations"
                         key={'checkin_a_'+props.id}
                    >
                        {showInfoIconIn && <div className="medium-1 column text-center  hide-for-small-only">
                            <div style={{display: "flex", height: "100%", float: "left",paddingLeft:"75%"}}>
                                <HtmlTooltip key={"checkin_a_i_tool_"+props.id} title={<React.Fragment key={"checkin_a_i_frag_"+props.id}>{<ADJUSTMENT_HELP_TEXT key={"checkin_a_i_help_"+props.id} content={infoTextIn}/>}</React.Fragment>} enterDelay={200} leaveDelay={500}>
                                    <label className="inb-form__controlLabel" style={{height:"60%"}}>
                                        <a data-tooltip-id="my-tooltip-data-html">
                                            <i className="inb-ico fi fi-info" style={{fontSize:"2.2rem"}}> </i>
                                        </a>
                                        {/* <i className="inb-ico fi fi-info"> </i>*/}
                                    </label>
                                </HtmlTooltip>
                            </div>
                        </div>}
                        <div
                            className={"tour__marker "+(showInfoIconIn?"medium-2":"medium-3")+" medium-offset-1 column text-center"}
                            style={{marginLeft: "0"}}
                            title={t('location_of_checkin')}>
                            <div style={{display: "flex", height: "100%", float: "right", paddingBottom: "10px"}}>
                                {(checkin.location_checkin_name === '' )&&
                                    <p style={{marginTop: "auto",marginBottom: "auto"}} title={t('location_yet_undefined')}>
                                        {t('location_yet_undefined')}
                                    </p>
                                }

                                {checkin.location_checkin_name !== '' &&
                                    <p style={{marginBlock: "auto"}}>
                                        {checkin.location_checkin_name}
                                    </p>
                                }
                                <i className="fi fi-marker"
                                   style={{
                                       marginTop: "auto",
                                       marginBottom: "auto",
                                       marginLeft: "0.8rem",
                                       fontSize: "2.2rem"
                                   }}>
                                </i>
                            </div>
                        </div>

                        <div className="medium-6 small-12 column clearfix">
                            <p className="tour__state text-center"
                               style={{marginBlock: "0", paddingBottom: "0", fontSize: "0.8rem"}}>
                                {checkin.checkout !== '' && checkin.checkout != null && rbac.hasPermission('edit') &&
                                    <>
                                        <button className="button round hollow" style={{padding: "2px 4px"}}>
                                            <i className="fi fi-check" style={{fontSize: "0.8rem"}}>
                                            </i>
                                        </button>
                                    </>
                                }
                                {t(checkin.status, null, 'capital') + (checkin.resource != null ? ':' : '')}

                                {checkin.resource != null &&
                                    <>
                                        {rbac.hasPermission('edit')?<a href={"/resources?id=" + checkin.resource.id + "&path=/reservationsList"}> {checkin.resource.name}</a>:checkin.resource.name}
                                    </>
                                }
                            </p>
                            <div className="tour__timeline">

                            </div>
                            <p className="float-left tour__checkin"
                               style={checkin.first_lock_usage !== null?{maxHeight: "16px"}:{maxHeight: "16px", paddingTop:"8px"}}>
                           <span title={moment(checkin.checkin).format(dateFormat(language,true,true))} style={{whiteSpace:"nowrap"}}>
                               {moment(checkin.checkin).format(dateFormat(language,true,true))}
                           </span>
                                {checkin.first_lock_usage !== null &&
                                    <>
                            <span title={t('first_usage_lock', null, 'capital')} style={{whiteSpace:"nowrap"}}>
                                <i className="fi fi-unlock" style={{paddingInline: "6px"}} title={t('first_usage_lock', null, 'capital')}>
                                </i>
                                {moment(checkin.first_lock_usage).format(dateFormat(language,true,true))}
                            </span>
                                    </>
                                }

                                {/*{checkin.first_lock_usage === null && props.reservation.first_usage !== null &&
                            <>
                            <span title={t('first_usage_lock', null, 'capital') + " " + moment(props.reservation.first_usage).format(dateFormat(language,true,true))}  style={{whiteSpace:"nowrap"}}>
                                <i className="fi fi-unlock" style={{paddingLeft: "6px",paddingRight: "6px"}} title={t('first_usage_lock', null, 'capital')}>
                                </i>
                                {moment(props.reservation.first_usage).format(dateFormat(language,true,true))}
                            </span>
                            </>
                            }*/}
                                {/*{checkin.comment_checkin}*/}


                            </p>
                            <>
                                {checkin.checkout !== '' && checkin.checkout != null &&
                                    <>
                                        <p className="float-right tour__checkout"
                                           style={{float: "right", textAlign: "right", width: "30%",paddingTop:"8px"}}>
                                        <span title={moment(checkin.checkout).format(dateFormat(language,true,true))}>
                                        {moment(checkin.checkout).format(dateFormat(language,true,true))}</span>


                                        </p>
                                        {props.app_user_role !== 'user' && (checkin.checkout !== '' || checkin.checkout !== null) && rbac.hasPermission('edit') &&
                                            <>
                                                <a className="checkin-out-link" href="#" onClick={(e) => {openCheckin(e, checkin)}}
                                                   style={{display: "block", fontSize: "0.9rem", textAlign: "center",paddingTop:"5px"}}>
                                                    {t('see_completed_checkin_out', null, 'capital')}
                                                </a>
                                            </>
                                        }

                                    </>
                                }
                                {checkin.checkin !== '' && checkin.checkin != null && checkin.status !== 'cancelled' && props.app_user_role !== 'user' && (checkin.checkout === '' || checkin.checkout === null) && rbac.hasPermission('edit')  &&
                                    <>
                                        <p className="float-right tour__checkout" style={{float: "right",paddingTop:"8px"}}>
                                            {t(checkin.status)}
                                            <a className="checkin-out-link" onClick={(e) => {openCheckin(e,checkin)}}
                                               style={{display: "block", fontSize: "0.9rem", textAlign: "center",paddingTop:"5px"}}>
                                                {t('checkout_reservation', null, 'capital')}
                                            </a>
                                        </p>
                                    </>
                                }

                            </>
                        </div>

                        <div className="tour__marker medium-2 small-6 column text-center"
                             style={{display: "flex"}}
                             title={t('location_of_checkout')}>
                            <div style={{display: "flex", height: "100%", float: "left", paddingBottom: "10px"}}>
                                {checkin.checkout != null &&
                                    <>
                                        <i className="fi fi-marker" style={{
                                            color: "blueviolet",
                                            marginRight: "0.8rem",
                                            marginTop: "auto",
                                            marginBottom: "auto",
                                            fontSize: "2.2rem"
                                        }}> </i>
                                        {checkin.location_checkout_name === '' &&
                                            <>
                                                <p style={{marginTop: "auto", marginBottom: "auto"}}
                                                   title={t('location_yet_undefined')}>
                                                    {t('location_yet_undefined')}
                                                </p>
                                            </>
                                        }
                                        {checkin.location_checkout_name !== '' &&
                                            <>
                                                <p style={{marginTop: "auto", marginBottom: "auto"}}>
                                                    {checkin.location_checkout_name}
                                                </p>
                                            </>
                                        }
                                    </>
                                }
                                {!checkout_completed &&
                                    <i className="fi fi-marker" style={{
                                        color: "grey",
                                        opacity: "0.7",
                                        marginRight: "0.8rem",
                                        marginTop: "auto",
                                        marginBottom: "auto",
                                        fontSize: "2.2rem"
                                    }} title={t('tour_in_progress')}> </i>
                                }
                            </div>
                        </div>

                        {showInfoIcon && <div className="medium-1 small-1 column text-center hide-for-small-only">
                            <div style={{display: "flex", height: "100%", float: "left"}}>
                                <HtmlTooltip key={"checkin_a_o_tool_"+props.id} title={<React.Fragment key={"checkin_a_o_frag_"+props.id}>{<ADJUSTMENT_HELP_TEXT key={"checkin_a_o_help_"+props.id} content={infoText}/>}</React.Fragment>} enterDelay={200} leaveDelay={500}>
                                    <label className="inb-form__controlLabel" style={{height:"60%"}}>
                                        <a data-tooltip-id="my-tooltip-data-html">
                                            <i className="inb-ico fi fi-info" style={{fontSize:"2.2rem"}}> </i>
                                        </a>
                                        {/* <i className="inb-ico fi fi-info"> </i>*/}
                                    </label>
                                </HtmlTooltip>
                            </div>
                        </div>}
                    </div>


                    {/*   {typeof checkin.checkout !== 'undefined' && checkin.checkout !== null && (
                    <div style={{marginLeft: "16px", paddingBottom: "0", backgroundColor: "#f3f3f3", marginTop: '10 px'}} className="inb-reservation inb-reservation--bikesharing inb-c-item-details-row row">
                        <div className="medium-9">
                            <p className="internal_note">{props.reservation.internal_note}</p>
                        </div>
                    </div>
                )}*/}

                    {/*Mobile*/}
                    <div className="inb-reservation inb-reservation--bikesharing inb-c-item-details-row row show-for-small-only"
                         style={{ marginTop:"3px",paddingBottom: "0", backgroundColor: "#f3f3f3",width: "100%"}}
                         data-inb-reservation={props.id}
                         data-inb-context="reservations"
                         key={'checkin_a_m_'+props.id}
                    >
                        {showInfoIconIn &&<>
                            <div className="medium-1 column text-center hide-for-small-only">
                                <div style={{display: "flex", height: "100%", float: "left",paddingLeft:"75%"}}>
                                    <HtmlTooltip key={"checkin_a_m_i_tool_"+props.id} title={<React.Fragment key={"checkin_a_m_i_frag_"+props.id}>{<ADJUSTMENT_HELP_TEXT key={"checkin_a_m_i_help_"+props.id} content={infoTextIn}/>}</React.Fragment>} enterDelay={200} leaveDelay={500}>
                                        <label className="inb-form__controlLabel" style={{height:"60%"}}>
                                            <a data-tooltip-id="my-tooltip-data-html">
                                                <i className="inb-ico fi fi-info" style={{fontSize:"2.2rem"}}> </i>
                                            </a>
                                            {/* <i className="inb-ico fi fi-info"> </i>*/}
                                        </label>
                                    </HtmlTooltip>
                                </div>
                            </div>
                        </>}
                        <div className={"tour__marker "+(showInfoIconIn?"small-12":"small-12")+" medium-offset-1 column"}
                             style={{marginLeft: "0",fontWeight:'normal'}} title={t('location_of_checkin')}>
                            <div style={{display: "flex", height: "100%"}}>

                                {(checkin.location_checkin_name === '' )&&
                                    <p style={{marginBlock: 0, fontSize: "0.8rem"}} title={t('location_of_checkin')+': '+t('location_yet_undefined')}>
                                        {t('location_of_checkin')+': '+t('location_yet_undefined')}
                                    </p>
                                }

                                {checkin.location_checkin_name !== '' &&
                                    <p style={{marginBlock: 0, fontSize: "0.8rem"}}>
                                        {t('location_of_checkin')+': '+checkin.location_checkin_name}
                                    </p>
                                }
                                {/*<i className="fi fi-marker" style={{marginTop: "auto", marginBottom: "auto", marginLeft: "0.8rem", fontSize: "2.2rem"}}></i>*/}
                            </div>
                        </div>
                        {/*   <div className="tour__timeline">

                            </div>*/}
                        <div className="medium-6 small-12 column clearfix" style={{marginBottom:0}} >
                            <p className="float-left tour__checkin" style={checkin.first_lock_usage !== null?{width: "100%", fontWeight:'normal',marginBottom:0}:{width: "100%",  fontWeight:'normal', fontSize: "0.8rem",marginBottom:0}}>
                                    <span style={{fontSize: "0.8rem"}}>
                                        {t('checkIn')} {': '}
                                    </span>
                                <span title={moment(checkin.checkin).format(dateFormat(language,true,true))} style={{whiteSpace:"nowrap", fontSize: "0.8rem"}}>
                                        {moment(checkin.checkin).format(dateFormat(language,true,true))}
                                    </span>
                            </p>
                        </div>
                        {checkin.first_lock_usage !== null && <>
                            <div className="medium-6 small-12 column clearfix" style={{marginBottom:0}}>
                                <p className="float-left tour__checkin" style={{
                                    width: "100%", fontWeight: 'normal', fontSize: "0.8rem", marginBottom: 0
                                }}>
                                    <span style={{fontSize: "0.8rem"}}>
                                        {t('first_usage_lock', null, 'capital')} {': '}
                                    </span>
                                    <span title={t('first_usage_lock', null, 'capital')}
                                          style={{whiteSpace: "nowrap",fontSize: "0.8rem"}}>
                                        <i className="fi fi-unlock" style={{paddingInline: "6px", fontSize: "0.8rem"}}
                                           title={t('first_usage_lock', null, 'capital')}>
                                        </i>
                                        {moment(checkin.first_lock_usage).format(dateFormat(language, true, true))}
                                     </span>
                                </p>


                                {/*{checkin.first_lock_usage === null && props.reservation.first_usage !== null &&
                            <>
                            <span title={t('first_usage_lock', null, 'capital') + " " + moment(props.reservation.first_usage).format(dateFormat(language,true,true))}  style={{whiteSpace:"nowrap"}}>
                                <i className="fi fi-unlock" style={{paddingLeft: "6px",paddingRight: "6px"}} title={t('first_usage_lock', null, 'capital')}>
                                </i>
                                {moment(props.reservation.first_usage).format(dateFormat(language,true,true))}
                            </span>
                            </>
                            }*/}
                                {/*{checkin.comment_checkin}*/}

                            </div>
                        </>
                        }
                        <div className="tour__marker medium-2 small-12 column"
                             style={{display: "flex",fontWeight:'normal',marginBottom:0}}
                             title={t('location_of_checkout')}>
                            <div style={{display: "flex", height: "100%", float: "left"}}>
                                {checkin.checkout != null &&
                                    <>
                                        {checkin.location_checkout_name === '' &&
                                            <>
                                                <p style={{marginBlock: 0, fontSize: "0.8rem"}}
                                                   title={t('location_yet_undefined')}>
                                                    {t('location_of_checkout')+': '+t('location_yet_undefined')}
                                                </p>
                                            </>
                                        }
                                        {checkin.location_checkout_name !== '' &&
                                            <>
                                                <p style={{marginBlock: 0, fontSize: "0.8rem"}}>
                                                    {t('location_of_checkout')+': '+checkin.location_checkout_name}
                                                </p>
                                            </>
                                        }
                                    </>
                                }
                                {!checkout_completed &&
                                    <p style={{marginBlock: 0, fontSize: "0.8rem"}}
                                       title={t('location_yet_undefined')}>
                                        {t('location_of_checkout')+': '}</p>
                                }
                            </div>
                        </div>


                        {checkin.checkout !== '' && checkin.checkout != null &&
                            <>
                                <div className="medium-6 small-12 column clearfix" style={{marginBottom:0}}>
                                    <p className="float-left tour__checkout" style={{float: "left",  width: "100%", fontWeight:'normal', fontSize: "0.8rem",marginBottom:0}}>
                                            <span>
                                                {t('checkout')} {': '}
                                            </span>
                                        <span title={moment(checkin.checkout).format(dateFormat(language, true, true))}>
                                                {moment(checkin.checkout).format(dateFormat(language, true, true))}
                                            </span>
                                    </p>
                                </div>
                            </>
                        }
                        <div className="medium-6 small-12 column clearfix">
                            <p className="tour__state" style={{marginTop: "0", marginBottom: "0", paddingBottom: "0", fontSize: "0.8rem"}}>
                                {checkin.checkout !== '' && checkin.checkout != null && rbac.hasPermission('edit') &&
                                    <>
                                        <button className="button round hollow" style={{padding: "2px 4px"}}>
                                            <i className="fi fi-check" style={{fontSize: "0.8rem"}}>
                                            </i>
                                        </button>
                                    </>
                                }
                                {t(checkin.status, null, 'capital') + (checkin.resource != null ? ':' : '')}

                                {checkin.resource != null &&
                                    <>
                                        {rbac.hasPermission('edit')?<a href={"/resources?id=" + checkin.resource.id + "&path=/reservationsList"}> {checkin.resource.name}</a>:checkin.resource.name}
                                    </>
                                }
                            </p>

                        </div>
                        <div className="medium-6 small-12 column clearfix" style={{paddingBottom:"10px"}}>
                            {checkin.checkout !== '' && checkin.checkout != null &&
                                <>
                                    {props.app_user_role !== 'user' && (checkin.checkout !== '' || checkin.checkout !== null) && rbac.hasPermission('edit') &&
                                        <>
                                            <a className="checkin-out-link" href="#" onClick={(e) => {
                                                openCheckin(e, checkin)
                                            }} style={{
                                                display: "block",
                                                fontSize: "0.9rem",
                                                paddingTop: "5px"
                                            }}>
                                                {t('see_completed_checkin_out', null, 'capital')}
                                            </a>
                                        </>
                                    }</>}

                            {checkin.checkin !== '' && checkin.status !== 'cancelled' && checkin.checkin != null && Biscuit.get('user.role') !== 'user' && (checkin.checkout === '' || checkin.checkout === null) && rbac.hasPermission('edit') &&
                                <>
                                    <p className="tour__checkout"
                                    >
                                        <a className="checkin-out-link" onClick={(e) => {
                                            openCheckin(e, checkin)
                                        }} style={{
                                            display: "block",
                                            fontSize: "0.9rem",
                                            paddingTop: "5px"
                                        }}>
                                            {t('checkout_reservation', null, 'capital')}
                                        </a>
                                    </p>
                                </>
                            }


                        </div>


                        {showInfoIcon &&
                            <>
                                <div className="medium-1 small-12 column">
                                    <div style={{display: "flex", height: "100%", float: "left"}}>
                                        Info: {infoText.replace(new RegExp('//', 'g'),' ')}
                                        {/*<HtmlTooltip title={<React.Fragment>{<ADJUSTMENT_HELP_TEXT
                                                content={infoText}/>}</React.Fragment>} enterDelay={200}
                                                         leaveDelay={500}>
                                                <label className="inb-form__controlLabel" style={{height: "60%"}}>
                                                    <a data-tooltip-id="my-tooltip-data-html">
                                                        <i className="inb-ico fi fi-info"
                                                           style={{fontSize: "2.2rem"}}> </i>
                                                    </a>
                                                     <i className="inb-ico fi fi-info"> </i>
                                                </label>
                                            </HtmlTooltip>*/}
                                    </div>
                                </div>
                            </>
                        }
                    </div>


                    {/*   {typeof checkin.checkout !== 'undefined' && checkin.checkout !== null && (
                    <div style={{marginLeft: "16px", paddingBottom: "0", backgroundColor: "#f3f3f3", marginTop: '10 px'}} className="inb-reservation inb-reservation--bikesharing inb-c-item-details-row row">
                        <div className="medium-9">
                            <p className="internal_note">{props.reservation.internal_note}</p>
                        </div>
                    </div>
                )}*/}
                </>)
            })}

        </>
    );
}
export default CheckInAddition;
